import { SwatchCard } from './atoms/cards/SwatchCard';
import { LargePromptCard } from './atoms/cards/LargePromptCard';
import { ImageOptionCard } from './atoms/cards/ImageOptionCard';
import { PillCard } from './atoms/cards/PillCard';
import { ActionCard } from './atoms/cards/ActionCard';
import { SubsectionCard } from './atoms/cards/SubsectionCard';
import { CompositeCard } from './atoms/cards/CompositeCard';
import type { CardConfig } from './state/cardSchema';

export type CardRendererProps = {
  card: CardConfig;
};

export const CardRenderer = ({ card }: CardRendererProps) => {
  switch (card.kind) {
    case 'swatch':
      return <SwatchCard card={card} />;
    case 'largePrompt':
      return <LargePromptCard card={card} />;
    case 'imageCard':
      return <ImageOptionCard card={card} />;
    case 'pillGroup':
      return <PillCard card={card} />;
    case 'actionCard':
      return <ActionCard card={card} />;
    case 'subsection':
      return <SubsectionCard card={card} />;
    case 'composite':
      return <CompositeCard card={card} />;
    default: {
      const _exhaustive: never = card;
      return _exhaustive;
    }
  }
};
